import { trackCookieChoice } from "@/analytics/tracking";
import { Button } from "@/components/Button/Button";
import { navigateToCookiePolicy, navigateToPrivacyPolicy } from "@/components/TermsAndPolicyDialog/utils";
import { POSTHOG_VISIBLE } from "@/constants/posthog";
import { selectConsent, setConsent } from "@/store/slices/cookieConsentSlice";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Link, Typography } from "@mui/material";
import posthog from "posthog-js";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

export const CookieConsentDialog = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const consent = useSelector(selectConsent);

  const handleChoice = (choice: "all" | "deny") => {
    if (choice === "all") {
      posthog.opt_in_capturing();
    }
    trackCookieChoice(choice);
    dispatch(setConsent(choice));
  };

  if (consent !== undefined) {
    return null;
  }

  return (
    <Dialog
      open
      disableEscapeKeyDown
      sx={{
        ".MuiPaper-root": {
          width: "100%",
          maxWidth: "600px"
        }
      }}
    >
      <Box component="div" sx={{ display: "flex", width: "100%", alignItems: "center" }}>
        <DialogTitle {...POSTHOG_VISIBLE}>{t("title.cookiePolicy")}</DialogTitle>
      </Box>
      <Divider />
      <DialogContent>
        <Typography sx={{ whiteSpace: "pre-wrap" }}>
          <Trans
            t={t}
            components={{
              cookie: <Link component={"button"} onClick={navigateToCookiePolicy} />,
              privacy: <Link component={"button"} onClick={navigateToPrivacyPolicy} />
            }}
            i18nKey={"message.cookiePolicy"}
          />
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ padding: "1em", gap: "0.5em", justifyContent: "center", flexDirection: ["column", "row"] }}>
        <Button
          sx={{ flexGrow: 1, flexShrink: 0, flexBasis: 1, minWidth: ["100%", "fit-content"] }}
          variant="outlined"
          onClick={() => handleChoice("deny")}
          {...POSTHOG_VISIBLE}
        >
          {t("button.deny")}
        </Button>
        <Button
          sx={{ flexGrow: 1, flexShrink: 0, flexBasis: 1, minWidth: ["100%", "fit-content"] }}
          color={"primary"}
          onClick={() => handleChoice("all")}
          {...POSTHOG_VISIBLE}
        >
          {t("button.acceptAll")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
